import { useNavigate } from "react-router-dom";
import Modal from "../modal/modal"
import WrapperEmpty from "../wrapper/wrapper-empty";

interface Props {
    title: string,
    onClose: () => void;
}
const NeedProfile = ({ onClose, title }: Props) => {
    const navigate = useNavigate();
    const handleGoToProfile = () => {
        onClose();
        navigate('/home'); // или путь к странице создания/редактирования профиля
    };
    return (
        <Modal header={title} onClose={onClose}>

            <WrapperEmpty>
                <svg
                    className="w-16 h-16 mx-auto mb-4 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                </svg>
                <h3 className="text-xl font-semibold mb-2">Требуется профиль</h3>
                <p className="text-gray-600 mb-6">
                    Для доступа необходимо создать профиль.
                    Это займет всего пару минут.
                </p>
                <div className="space-y-3">
                    <button
                        onClick={handleGoToProfile}
                        className="btn-link w-full"
                    >
                        Создать профиль
                    </button>
                    <button
                        onClick={onClose}
                        className="btn-link btn-link-cancel w-full"
                    >
                        Отмена
                    </button>
                </div>
            </WrapperEmpty>
        </Modal>
    )
}

export default NeedProfile;